import { ReactElement, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Layout, Menu, Image, Descriptions, Button,InputNumber, Breadcrumb } from "antd";
import { HomeOutlined, UserOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { getAuthState, getProductState, getCategoryState } from "../../redux/selectors";
import {SET_LOADING_STATE, RESET_LOADING_STATE } from "../../redux/constants";
import "../../assets/css/index.css";
import api from "../../redux/api/axiosInstance";
import { ShopHeaderBar, ShopSideBar } from "../../components";
import product from "../../redux/reducer/product";
import Loading from "../../components/Loading";

export function CategoryProduct(): ReactElement {
    
const dispatch = useDispatch();
const history = useHistory();
const { t } = useTranslation();
const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const { categoryId } = useParams<{ categoryId: string }>();
const { Meta } = Card;
const { currentUser } = useSelector(getAuthState);
const [loading, setLoading] = useState<boolean>(false);
const [products, setProducts] = useState<any[]>([]);


const getProductByCategory = async (val : any) => {
    await api.post("getProducts", { category: categoryId})
    .then(res => {
        setProducts(res.data.productData);
        setLoading(false);
    })
    .catch(e => {
        setLoading(false);
        console.log(e);
    })
}

useEffect(() => {
    getProductByCategory(categoryId);
}, []);

const goProductDetail = (record: any) => {
    history.push(`/shop/${record}`);
};

return (
    <Layout>
        <ShopSideBar />
        <Layout>
            {loading && <Loading /> }
            <Content style={{ margin: '50px 16px 50px'}}>
                <Row gutter={[20,10]}>
                    <Col span={24}>
                    <Breadcrumb>
                        <Breadcrumb.Item href="">
                            <HomeOutlined />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                            <span>Shop</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Application</Breadcrumb.Item>
                    </Breadcrumb>
                    </Col>
                    {products.map(({product_id,name,cost,photo,currency}) => 
                    <Col xs={12} sm={12} md={8} lg={8} xl={4}>
                        <Card
                            style={{width:"100%",color:"white"}}
                            hoverable
                            cover={<img className="shop-product-image" alt="example" src={photo} />}
                            onClick={() => goProductDetail(product_id)}
                        >
                            <Meta title={name} description={currency+cost} />
                            {/* <Button type="primary"  icon={<DownloadOutlined />} size={size}>Checkout</Button> */}
                        </Card>
                    </Col>
                    )}
                </Row>
            </Content>
            <Footer style={{ textAlign: 'center',background:"#2196f3",color:"white",fontWeight:"bold",marginTop:150 }}>Set Point ©{new Date().getFullYear()}</Footer>
        </Layout>
    </Layout>
  );
}
